
        export enum ComponentEnum {
            "Fondue - Accordion" = "Accordion",
"Fondue - AccordionHeader" = "AccordionHeader",
"Fondue - AccordionHeaderIcon" = "AccordionHeaderIcon",
"Fondue - AddBlockButton" = "AddBlockButton",
"Fondue - AssetInput" = "AssetInput",
"Fondue - AssetThumbnail" = "AssetThumbnail",
"Fondue - Badge" = "Badge",
"Fondue - BadgeStatusIcon" = "BadgeStatusIcon",
"Fondue - Box" = "Box",
"Fondue - BreadcrumbItem" = "BreadcrumbItem",
"Fondue - Breadcrumbs" = "Breadcrumbs",
"Fondue - CurrentBreadcrumbItem" = "CurrentBreadcrumbItem",
"Fondue - FormattedBreadcrumbs" = "FormattedBreadcrumbs",
"Fondue - Button" = "Button",
"Fondue - ButtonGroup" = "ButtonGroup",
"Fondue - Card" = "Card",
"Fondue - Checkbox" = "Checkbox",
"Fondue - Checklist" = "Checklist",
"Fondue - CollapsibleWrap" = "CollapsibleWrap",
"Fondue - ColorInputTitle" = "ColorInputTitle",
"Fondue - ColorPickerFlyout" = "ColorPickerFlyout",
"Fondue - ColorPickerTrigger" = "ColorPickerTrigger",
"Fondue - BrandColorPicker" = "BrandColorPicker",
"Fondue - ColorInput" = "ColorInput",
"Fondue - ColorPicker" = "ColorPicker",
"Fondue - ColorPreview" = "ColorPreview",
"Fondue - CustomColorPicker" = "CustomColorPicker",
"Fondue - Container" = "Container",
"Fondue - DatePicker" = "DatePicker",
"Fondue - DatePickerTrigger" = "DatePickerTrigger",
"Fondue - Dialog" = "Dialog",
"Fondue - DialogBody" = "DialogBody",
"Fondue - DialogFooter" = "DialogFooter",
"Fondue - DialogHeader" = "DialogHeader",
"Fondue - Divider" = "Divider",
"Fondue - DropZone" = "DropZone",
"Fondue - Dropdown" = "Dropdown",
"Fondue - EditableText" = "EditableText",
"Fondue - FieldsetHeader" = "FieldsetHeader",
"Fondue - FilterableMultiSelect" = "FilterableMultiSelect",
"Fondue - Flex" = "Flex",
"Fondue - Flyout" = "Flyout",
"Fondue - FlyoutFooter" = "FlyoutFooter",
"Fondue - Overlay" = "Overlay",
"Fondue - Form" = "Form",
"Fondue - FormControl" = "FormControl",
"Fondue - FormField" = "FormField",
"Fondue - FrontifyPattern" = "FrontifyPattern",
"Fondue - Grid" = "Grid",
"Fondue - InlineDialog" = "InlineDialog",
"Fondue - InputLabel" = "InputLabel",
"Fondue - LegacyCollectionItem" = "LegacyCollectionItem",
"Fondue - LegacyOrderableList" = "LegacyOrderableList",
"Fondue - LegacyTextarea" = "LegacyTextarea",
"Fondue - BrightHeader" = "BrightHeader",
"Fondue - LegacyTooltip" = "LegacyTooltip",
"Fondue - LoadingBar" = "LoadingBar",
"Fondue - LoadingCircle" = "LoadingCircle",
"Fondue - Menu" = "Menu",
"Fondue - MenuItem" = "MenuItem",
"Fondue - MenuItemContent" = "MenuItemContent",
"Fondue - Modal" = "Modal",
"Fondue - ModalBody" = "ModalBody",
"Fondue - ModalFooter" = "ModalFooter",
"Fondue - ModalHeader" = "ModalHeader",
"Fondue - ModalVisual" = "ModalVisual",
"Fondue - MultiInput" = "MultiInput",
"Fondue - MultiSelect" = "MultiSelect",
"Fondue - NumberInput" = "NumberInput",
"Fondue - OrderableList" = "OrderableList",
"Fondue - OverflowMenu" = "OverflowMenu",
"Fondue - PasswordInput" = "PasswordInput",
"Fondue - Popover" = "Popover",
"Fondue - Popper" = "Popper",
"Fondue - RadioButton" = "RadioButton",
"Fondue - RadioList" = "RadioList",
"Fondue - RadioPill" = "RadioPill",
"Fondue - RichTextEditor" = "RichTextEditor",
"Fondue - ScrollWrapper" = "ScrollWrapper",
"Fondue - SegmentedControls" = "SegmentedControls",
"Fondue - Slider" = "Slider",
"Fondue - Stack" = "Stack",
"Fondue - Switch" = "Switch",
"Fondue - Table" = "Table",
"Fondue - TableCell" = "TableCell",
"Fondue - TableColumnHeader" = "TableColumnHeader",
"Fondue - TableHeaderRow" = "TableHeaderRow",
"Fondue - TableRow" = "TableRow",
"Fondue - TabItem" = "TabItem",
"Fondue - Tabs" = "Tabs",
"Fondue - Tag" = "Tag",
"Fondue - TextInput" = "TextInput",
"Fondue - Textarea" = "Textarea",
"Fondue - Toast" = "Toast",
"Fondue - Tooltip" = "Tooltip",
"Fondue - TooltipIcon" = "TooltipIcon",
"Fondue - Tree" = "Tree",
"Fondue - Trigger" = "Trigger"
        };
    